<!--
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-05-30 11:57:09
 * @Description: 
-->
<style scoped>
.expand-row {
  margin-bottom: 16px;
}

.avatars {
  width: 70px;
  height: 70px;
  margin-right: 10px;
}
</style>
<template>
  <div>
    <List item-layout="vertical">
      <ListItem v-for="item in row"
                :key="item.good_title">
        <img :src="item.good_thumb"
             @click="showViewer"
             class="avatars f-l" />

        <ListItemMeta :title="item.good_title"
                      :description="item.good_spec_name"
                      class="listTitle">
        </ListItemMeta>
        <template>
          <div class="goodsOrderbtn"
               v-if="item.is_orderphoto>0"
               @click="showOrderPhoto(item.order_id,item.good_id)">订单快照</div>
        </template>
        <template slot="action">
          <li>
            数量: {{ item.nums }}
          </li>
          <li>
            单价:{{ item.price }}元
          </li>
          <li>
            总价:{{ item.total_prices }}元
          </li>
          <li>
            状态: {{ item.status==1 ? '退回' : '正常'}}
          </li>
        </template>
      </ListItem>
    </List>
    <!-- 详情弹层 start-->
    <Drawer width="50"
            v-model="modal1"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <List>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">封面图:</span>
            </label>
            <img :src="detaildata.thumb"
                 style="width: 200px;height: 200px;" />
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">图集:</span>
            </label>
            <div v-if="detaildata.album!=null&&detaildata.album!=''">
              <img v-for="(item,key) in detaildata.album.split(',')"
                   :src="$publicData.ossUrl+item"
                   style="width: 200px;height: 200px;" />
              <!--<Avatar v-for="(item,key) in detaildata.album.split(',')" shape="square" icon="ios-person" size="large" :src="item"/>-->
            </div>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="6">
            <span style="font-size: 14px;font-weight: bold">商品名称:</span>
            {{detaildata.good_title }}
            </Col>
            <Col span="6">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">规格名称:</span>
              {{detaildata.good_spec_name }}
            </label>
            </Col>
            <Col span="6">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">分类名称:</span>
              {{detaildata.good_cate_title }}
            </label>
            </Col>
            <Col span="6">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">品牌名称:</span>
              {{detaildata.good_brand }}
            </label>
            </Col>

          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="12">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">商品单价:</span>
              {{detaildata.prices }}
            </label>
            </Col>
            <Col span="12">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">购买数量:</span>
              {{detaildata.nums }}
            </label>
            </Col>
            <Col span="12">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">支付金额:</span>
              {{detaildata.total_prices }}
            </label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">商品内容:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.content"></label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">商品描述:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.descript"></label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">店铺图:</span>
            </label>
            <img :src="detaildata.shop_thumb"
                 style="width: 200px;height: 200px;" />
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">店铺名称:</span>
              {{ detaildata.shop_name }}
            </label>
            </Col>
          </Row>
        </ListItem>
      </List>
    </Drawer>
    <!-- 详情弹层 end -->
  </div>
</template>
<script>
export default {
  props: {
    row: Array,
    showViewerFun: {
      type: Function,
      default: function () {
        // console.log("提交");
        return;
      }
    },
  },
  data () {
    return {
      modal1: false, // 订单规格弹层显示状态
      exportLoading: false,
      detaildata: [],
    };
  },
  methods: {
    showViewer () {
      this.showViewerFun()
    },
    // 查看详情
    showOrderPhoto: function (order_id, good_id) {
      this.modal1 = true;
      this.$api.goodorder.photo({ order_id: order_id, good_id: good_id }).then(res => {
        if (res.code == 200) {
          this.detaildata = res.result;
        }
      });
      return;
    },
  }
}
</script>
<style>
.goodsOrderbtn {
  /* position: absolute;
  left: 115px; */
  height: 20px;
  background: #999;
  color: #fff;
  text-align: center;
  line-height: 20px;
  padding: 0 10px;
  cursor: pointer;
  display: inline-block;
}
</style>